import React, { useState } from "react";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const AddCatelogImage = () => {
  const navigate = useNavigate();
  const { id, name } = useParams();

  const token = getCookie("token");
  const userid = getCookie("userid");
  
  
  const [formData, setFormData] = useState({
    catagory: "",
    remark: "",
  });

  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://api.dqr-display-tms.eventum.co.in/api/CatalogStructureOperation/SubUser/Insert",
        {
          catalogid: parseInt(id), // Convert to number
          remark: formData.remark,
          active: true,
          name: formData.catagory,
        },
        {
          headers: {
            accept: "text/plain",
            UserId: userid,
            "X-Authorization": token,
            "Content-Type": "application/json-patch+json",
          },
        }
      );

      // Check if API response indicates success
      if (response.data && response.data.isresponse && response.data.responsestatus === "SUCCESS") {
        setMessage("Catalog added successfully!");
        setTimeout(() => {
          navigate(`/showcatelog/${id}`);
        }, 3000);
      } else {
        // Display error message from API response
        setMessage(response.data?.errormsg || "Failed to add Catalogue");
      }
    } catch (error) {
      setMessage("Failed to add Catalogue: " + (error.response?.data?.errormsg || error.message));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Add Catalogue</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Category Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.catagory}
                                onChange={handleChange}
                                placeholder="Enter category name"
                                name="catagory"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Category Description</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.remark}
                                onChange={handleChange}
                                placeholder="Enter description"
                                name="remark"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            id="add-sub"
                            className="btn btn-info"
                          >
                            Add
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            right: "10px",
            width: "25%",
            zIndex: "9999",
          }}
        >
          <div
            className={`alert d-flex align-items-center ${
              message.includes("successfully")
                ? "alert-success"
                : "alert-danger"
            }`}
            role="alert"
          >
            <div>{message}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddCatelogImage;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}